import { render, staticRenderFns } from "./BusForm.vue?vue&type=template&id=00849a5e&scoped=true&"
import script from "./BusForm.vue?vue&type=script&lang=js&"
export * from "./BusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00849a5e",
  null
  
)

export default component.exports